var _defs, _text, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsKontaktGrn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.02 34.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #defc70;\n      }\n\n      .st1 {\n        fill: #fff;\n        font-family: DINPro-Regular, DINPro;\n        font-size: 14.07px;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(30.21 22.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.12,8.17H3.74l-.68.68v17.79l.68.68h26.38l.68-.68V8.85l-.68-.68ZM22.98,18.84l-.92,1.01,6.71,6.11H5.59l6.46-6.14-.94-.99-6.7,6.37v-14.72l12.04,11.13h.92l12.06-11.16v14.28l-6.46-5.89ZM5.4,9.53h23.03l-11.51,10.65L5.4,9.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsKontaktGrn);
export default __webpack_public_path__ + "static/media/Icons_Kontakt_grün.52374ff622cb824cabb33c59b990b10c.svg";
export { ForwardRef as ReactComponent };